export const endpoints = {
  importSetOptions: 'importSet/options',
  codetableOptions: 'importSet/optionsCollection/options',
  optionsCollection: (importSetId: number, codetableId: number) => `importSet/${importSetId}/optionsCollection/${codetableId}/search`,
  metadata: (id: number) => `importSet/optionsCollection/${id}/metadata`,
  codetableSearch: (codetableId: number) => `importSet/optionsCollection/${codetableId}/search`,
  categoryOptions: (optionCollectionId: number) => `importSet/optionsCollection/${optionCollectionId}/search`,
  optionPath: (optionCollectionId: number, codeId: number) => `importSet/optionsCollection/${optionCollectionId}/code/${codeId}/path`,
  saveExternalValue: (importSetId: number) => `importSet/${importSetId}/mapping`
};
